import React, { useState } from 'react';
import moment, { Moment } from 'moment';

import { AverageDischargeChart } from '@components/chart/averageDischargeChart';
import { BatteryCentricService, IBatteryAverageDischargeData } from '../../../services/shared/battery/batteryCentricService';
import { useWorldAction } from '../../../lib/useWorldAction';
import { BatteryLevelChart } from './batteryLevelChart';
import { DataLoading } from '@components/loading/dataLoading';
import { useTranslation } from '@lib/useTypedTranslation';
import './styles.css';


interface IProps {
  id: string,
  data: IBatteryAverageDischargeData[],
  isLoading?: boolean
}

export function BatteryCharts(props: IProps) {
  const { t } = useTranslation('performance');
  const [batteryLevelDate, setBatteryLevelDate] = useState(moment.utc().endOf('day').valueOf());
  const title = t('AVERAGE_HOURLY_DISCHARGE_PAST_30DAYS');
  const service = new BatteryCentricService();

  const doGetLast24HourBatteryLevel = useWorldAction(service.getSmartBatteryLast24HourBatteryLevel);
  async function loadDetails(): Promise<any> {
    return await doGetLast24HourBatteryLevel(props.id, batteryLevelDate);
  }

  const onSetDate = (date: string | Moment) => setBatteryLevelDate(moment(date).utc().endOf('day').valueOf());

  return (
    <div className="row details_information h-100">
      <div className="col-md-6 col-sm-12 col-12">
        <AverageDischargeChart
          data={props.data}
          title={title}
          className={"battery-average-discharge-chart"}
          setDate={onSetDate}
          isLoading={props?.isLoading}
        />
      </div>
      <div className="col-md-6 col-sm-12 col-12">
        <DataLoading key={`${props.id}:${batteryLevelDate}`} loadData={loadDetails} transparentOverlay={true}>
          <BatteryLevelChart
            data={null}
            date={batteryLevelDate}
          />
        </DataLoading>
      </div>
    </div>
  );
}
